// Up to two initials of a name, for avatars. (The account menu itself is components/AccountMenu.js.)
export const initials = (name = '') =>
  name.split(' ').filter(Boolean).slice(0, 2).map((p) => p[0].toUpperCase()).join('') || 'AD';
